module.exports = __webpack_public_path__ + "media/typy/motocykle-785b454f.png";